import React from "react";
import { graphql } from "gatsby"
import Block from "../../Block";
import { isEmpty } from "utils/lodashExtracts";
import { extractId } from "utils/youtubeHelper";
import VideoThumbnail from "components/common/VideoThumbnail";

class UGBVideo extends Block {
  render() {
    const { block, context } = this.props;
    const { attributes } = block;
    const videoId = attributes.videoID || extractId(attributes.videoLink)
    const videoUrl = `https://www.youtube.com/embed/${videoId}?feature=oembed&autoplay=1&rel=0`;
    const video = {
      extFilename: `https://img.youtube.com/vi/${videoId}/0.jpg`,
      alt: "",
      intro: "",
      video: videoUrl,
      youtube: { videoId }
    };
    if(isEmpty(videoId)){
      console.log(`[VIDEOBUG] UGBVideo ${videoUrl} in ${context.slug} - videoId ${videoId}`)
    }
    return <VideoThumbnail data={video} showPlayIcon={true} />;
  }
}

export const query = graphql`
  fragment BlogBlockVideo on WpUgbVideoPopupBlock {
    originalContent
    attributes {
      ... on WpUgbVideoPopupBlockAttributes {
        align
        className
        blockDescription
        previewBackgroundMediaUrl
        videoID
        videoLink
      }
    }
  }
`;

class UGBVideoFactory {
  get type() {
    return "ugb/video-popup";
  }

  create(props) {
    return <UGBVideo {...props} />;
  }
}

export default UGBVideoFactory;
